/**
 * Single source of truth for the post-event (archival) state of Analog Reunion 2026.
 *
 * The May 15–17, 2026 event is complete. The site is preserved as a historical
 * record: every page stays reachable, but nothing on the public site may start a
 * transaction. UI removal is backed by an event-scoped backend guard
 * (see supabase/functions/_shared/sales-closed.ts).
 */

export const POST_EVENT = {
  eventName: "Analog Reunion 2026",
  dateRange: "May 15–17, 2026",
  startDate: "2026-05-15",
  endDate: "2026-05-17",
  venue: "Wildhaven Sonoma",
  /** Exact notice copy required on every preserved public page. */
  endedNotice:
    "Analog Reunion 2026 took place May 15–17, 2026. The event has ended and ticket sales are closed.",
  /** Nonprofit disclosure. Not a donation claim; no tax-deductibility implied. */
  nonprofitDisclosure:
    "Analog Reunion was produced by Launch Pad Foundation, a 501(c)(3) public charity. EIN: 83-4195654.",
  pastAttendeeLabel: "Past attendee receipt/support",
} as const;

/** Global front-end flag: no public route may initiate a 2026 transaction. */
export const SALES_CLOSED = true;

/** Height reserved for the fixed post-event notice bar. */
export const POST_EVENT_NOTICE_HEIGHT_MOBILE = 64;
export const POST_EVENT_NOTICE_HEIGHT_DESKTOP = 44;
